<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div class="align-self-center" v-if="!codigoColaboradorDeCampo">
                  <button
                    class="btn btn-light d-flex align-items-center text-dark p-1 border-0"
                    @click="$router.go(-1)"
                  >
                    <i class="nc-icon nc-stre-left font-weight-bold"></i>
                    <p class="m-0 ml-1">Voltar a lista</p>
                  </button>
                </div>
                <div class="buttons-container">
                  <div
                    v-if="codigoOs || codigoColaboradorDeCampo"
                    style="margin-right: 10px;"
                  >
                    <button class="btn btn-success btn-fill" @click="getOsPdf">
                      Baixar OS
                    </button>
                  </div>
                  <div v-if="!codigoColaboradorDeCampo">
                    <button
                      style="margin-right: 10px;"
                      type="submit"
                      class="btn btn-success btn-fill"
                      @click="salvarOs"
                    >
                      Salvar
                    </button>
                  </div>
                  <div style="display: flex" v-if="codigoColaboradorDeCampo">
                    <div>
                      <button
                        style="margin-right: 10px;"
                        class="btn btn-danger btn-fill"
                        @click="aprovarOuNegarOs(false)"
                        :disabled="aprovadoOuNegadoPeloUsuario"
                      >
                        Negar
                      </button>
                    </div>
                    <div>
                      <button
                        style="margin-right: 10px;"
                        class="btn btn-success btn-fill"
                        @click="aprovarOuNegarOs(true)"
                        :disabled="aprovadoOuNegadoPeloUsuario"
                      >
                        Aprovar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin: 3%">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Cliente - Cadastro O.S.</h4>
                      </div>
                    </div>

                    <div class="row">
                      <div v-if="nomeCliente" class="col-md-6">
                        <base-input
                          disabled="true"
                          label="Nome - Cliente"
                          v-model="nomeCliente"
                        ></base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input
                          label="Custo"
                          type="number"
                          v-model="os.custo"
                          :disabled="codigoColaboradorDeCampo"
                        ></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="d-flex flex-column mt-1">
                          <label
                            for="ativo"
                            class="d-flex align-items-center mb-0 pr-2 mb-1 "
                            >Colaborador</label
                          >
                          <multiselect
                            v-model="os.colaboradorDeCampo"
                            :options="listaVendedoresEColaboradores"
                            :showLabels="false"
                            placeholder="Selecione um Colaborador"
                            :customLabel="codigoENome"
                            class="usuario-multiselect"
                            :disabled="codigoOs || codigoColaboradorDeCampo"
                          >
                            <span slot="noResult">Não encontrado</span>
                          </multiselect>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label for="tecnologia">Atividade</label>
                        <select
                          v-model="os.atividade"
                          class="form-control"
                          :disabled="codigoColaboradorDeCampo"
                        >
                          <option
                            v-for="option in atividadeOptions"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-6 col-sm-12 d-flex flex-column">
                        <label class="mr-2">Data de Início</label>
                        <date-picker
                          format="DD/MM/YYYY"
                          v-model="os.dataInicio"
                          style="width: 100%"
                          type="date"
                          :disabled="codigoColaboradorDeCampo"
                        ></date-picker>
                      </div>
                      <div class="col-md-6 col-sm-12 d-flex flex-column">
                        <label class="mr-2">Data de Fim</label>
                        <date-picker
                          format="DD/MM/YYYY"
                          v-model="os.dataFim"
                          style="width: 100%"
                          type="date"
                          :disabled="codigoColaboradorDeCampo"
                        ></date-picker>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label>Descrição</label>
                        <textarea
                          rows="5"
                          class="form-control border-input"
                          placeholder="Observações"
                          v-model="os.descricao"
                          :disabled="codigoColaboradorDeCampo"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import OrdemDeServicoService from 'src/services/ordemDeServico';
import ClientesService from 'src/services/clientes';
import { imgData } from 'src/shared/os-pdf';
import jsPDF from 'jspdf';
import formatDateFns from 'date-fns/format';
import Multiselect from 'vue-multiselect';
import ptBR from 'date-fns/locale/pt-BR';
import Modal from 'src/components/Modal';
import { MENSAGEM_ERRO_DEFAULT } from 'src/utils/constants';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Multiselect,
    DatePicker,
    Modal
  },
  data() {
    return {
      os: {
        colaboradorDeCampo: '',
        atividade: '',
        descricao: '',
        dataInicio: '',
        dataFim: '',
        custo: ''
      },
      atividadeOptions: [
        { value: 'instalacao', label: 'Instalação' },
        { value: 'visita-tecnica', label: 'Visita Técnica' },
        { value: 'manutencao-corretiva', label: 'Manutenção Corretiva' }
      ],
      listaVendedoresEColaboradores: [{ nome: '', codigo: '' }],
      lead: undefined,
      dadosUsina: {},
      propostaGerada: {},
      modulos: 0,
      qtdKwp: '',
      tipoTecnologia: '',
      aprovadoOuNegadoPeloUsuario: false
    };
  },
  props: {
    nomeCliente: {
      type: String,
      required: false
    },
    idCliente: {
      type: String,
      required: false
    },
    clientCode: {
      type: String,
      required: false
    }
  },
  created() {
    this.codigoOs = this.$router.history.current.params.codigoOs;
    this.codigoColaboradorDeCampo = this.$router.history.current.params.codigoColaboradorDeCampo;
    if (this.codigoColaboradorDeCampo) {
      this.getInfoByColaboradorDeCampo();
    } else {
      this.loadColaboradoresEVendedores();
      this.getOs();
      this.getCliente();
    }
  },
  methods: {
    formatarDataPtBr(data) {
      return formatDateFns(data, 'dd/MM/yyyy', {
        locale: ptBR
      });
    },
    salvarOs() {
      const loader = this.createLoading();
      var os = this.os;
      if (this.os._id) {
        OrdemDeServicoService.atualizar(os)
          .then(() => {
            this.notify({
              message: 'OS atualizada com sucesso',
              type: 'success'
            });

            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;

            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      } else {
        os.cliente = this.idCliente;
        os.colaboradorDeCampo = os.colaboradorDeCampo._id;
        OrdemDeServicoService.salvar(os)
          .then(() => {
            this.notify({
              message: 'Ordem de serviço criada com sucesso',
              type: 'success'
            });

            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;

            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      }
    },
    aprovarOuNegarOs(aprovada) {
      const loader = this.createLoading();
      OrdemDeServicoService.aprovarOuNegarOs(
        this.codigoColaboradorDeCampo,
        aprovada
      )
        .then(response => {
          this.notify({ message: response.data.message, type: 'success' });
          this.aprovadoOuNegadoPeloUsuario = true;
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          const message = _.has(error, 'response.data.message')
            ? _.get(error, 'response.data.message')
            : MENSAGEM_ERRO_DEFAULT;
          this.notify({
            message,
            type: 'danger'
          });
          this.$router.replace('');
        });
    },
    aceitarServico() {},
    loadColaboradoresEVendedores() {
      OrdemDeServicoService.getColaboradoresDeCampoDisponiveis().then(
        response => {
          this.listaVendedoresEColaboradores = response.data;
        }
      );
    },
    getOs() {
      if (this.codigoOs) {
        const loader = this.createLoading();
        OrdemDeServicoService.getByCodigo(this.codigoOs)
          .then(response => {
            let os = { ...response.data };
            os.custo = os.custo.$numberDecimal;
            os.dataInicio = new Date(os.dataInicio);
            os.dataFim = new Date(os.dataFim);
            this.os = { ...os };
            this.nomeCliente = os.cliente.nomeCompleto;

            loader.hide();
          })
          .catch(error => {
            loader.hide();
            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;
            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      }
    },
    getCliente() {
      if (this.clientCode) {
        const loader = this.createLoading();

        ClientesService.getByCodigo(this.clientCode)
          .then(response => {
            var cliente;
            cliente = _.get(response, 'data');

            if (cliente.qtdKwp) {
              this.qtdKwp = cliente.qtdKwp.$numberDecimal;
            }
            this.propostaGerada = { ...cliente.propostaGerada };
            this.tipoTecnologia = cliente.tipoTecnologia;
            this.modulos = cliente.modulos.length;
            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;

            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      }
    },
    getOsPdf() {
      var doc = new jsPDF();
      doc.setFontSize(14);
      doc.addImage(imgData, 'JPEG', 15, 10, 180, 230);
      doc.text(55, 63, this.nomeCliente);
      doc.text(
        55,
        69,
        this.os.colaboradorDeCampo.nome
          ? `${this.os.colaboradorDeCampo.nome} ${this.os.colaboradorDeCampo.sobrenome}`
          : this.os.colaboradorDeCampo.razaoSocial
      );
      doc.text(55, 75, this.os.atividade);
      doc.setFontSize(10);

      doc.text(55, 81, this.os.descricao);
      doc.setFontSize(14);
      doc.text(20, 124, 'Potência:');
      doc.text(
        43,
        124,
        this.propostaGerada.rsWp
          ? String(this.propostaGerada.rsWp) + ' Kwp'
          : this.qtdKwp + ' Kwp'
      );
      doc.text(20, 130, 'Tecnologia:');
      doc.text(
        47,
        130,
        this.propostaGerada.kit
          ? this.propostaGerada.kit.tipoTecnologia
          : this.tipoTecnologia
      );

      doc.text(20, 136, 'Quantidade de Módulos:');
      doc.text(
        78,
        136,
        this.propostaGerada.kit
          ? String(this.propostaGerada.kit.moduloQuantidade)
          : String(this.modulos)
      );
      doc.setFontSize(10);
      doc.text(170, 14, this.formatarDataPtBr(this.os.dataInicio));
      doc.text(170, 25, this.formatarDataPtBr(this.os.dataFim));
      doc.setFontSize(14);
      doc.text(140, 270, '____________________');
      doc.text(140, 280, 'Aprovo Serviço');

      doc.save('OS Joule');
    },
    createLoading() {
      return this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
    },
    notify({ type, message }) {
      let icon = '';
      switch (type) {
        case 'info':
          icon = 'fa fa-info';
          break;
        case 'success':
          icon = 'fa fa-check';
          break;
        case 'danger':
          icon = 'fa fa-exclamation-triangle';
      }
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      });
    },
    codigoENome(user) {
      return `${user.codigo} ${
        user.nome ? `${user.nome} ${user.sobrenome}` : user.razaoSocial
      }`;
    },
    parseDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(5, 7);
      const day = date.slice(8, 10);
      return `${day}/${month}/${year}`;
    },
    getInfoByColaboradorDeCampo() {
      if (this.codigoColaboradorDeCampo) {
        const loader = this.createLoading();
        OrdemDeServicoService.getOsParaAprovacao(this.codigoColaboradorDeCampo)
          .then(response => {
            let os = { ...response.data };
            os.custo = os.custo.$numberDecimal;
            os.dataInicio = new Date(os.dataInicio);
            os.dataFim = new Date(os.dataFim);
            this.os = { ...os };
            this.nomeCliente = os.cliente.nomeCompleto;

            if (os.cliente.qtdKwp) {
              this.qtdKwp = os.cliente.qtdKwp.$numberDecimal;
            }
            this.propostaGerada = { ...os.cliente.propostaGerada };
            this.tipoTecnologia = os.cliente.tipoTecnologia;
            this.modulos = os.cliente.modulos.length;

            loader.hide();
          })
          .catch(error => {
            loader.hide();
            const message = _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : MENSAGEM_ERRO_DEFAULT;
            this.notify({
              message,
              type: 'danger'
            });
            this.$router.replace('');
          });
      }
    }
  }
};
</script>
<style scoped>
.height-fit-content {
  height: fit-content;
}
.crm-tabs .nav {
  display: block !important;
}

.relatorio-geracao-form {
  border-bottom: 1px solid #e0e0e0;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
